import type { ReactNode } from 'react';
import { IonFooter, IonToolbar } from '@ionic/react';

export interface ActionFooterProps {
  /** 操作鍵，橫向並排；要撐滿剩餘寬度的那顆加 `flex-1` */
  children: ReactNode;
}

/**
 * 固定在畫面或面板底部的操作列。
 *
 * 放在 `IonFooter` 而非內容末端：內容可捲動，按鈕跟著捲走的話，鍵盤開啟時就按不到。
 * safe-area 內距與鍵盤出現時的讓位也由 Ionic 處理。
 */
export function ActionFooter({ children }: ActionFooterProps) {
  return (
    <IonFooter className="ion-no-border">
      <IonToolbar>
        <div className="flex gap-3 px-4 pt-1 pb-2">{children}</div>
      </IonToolbar>
    </IonFooter>
  );
}
